module.exports = __webpack_public_path__ + "img/fig42.2da2814a.jpg";